import { useSelector, useDispatch } from 'react-redux';
import switchFuncSlice from './switchFuncSlice';

function useSwitchFunc() {
    const { funcId } = useSelector((state) => {
        return state.switchFunc;
    });
    const dispatch = useDispatch();
  
    function setFunc(id) {
      dispatch(switchFuncSlice.actions.setFunc(id));
    }
  
    return { funcId, setFunc };
}

export default useSwitchFunc;